import { useTranslation } from 'react-i18next';
import TenantPage from 'layouts/TenantPage';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { transportDocumentLineService } from '../api/transport-document-line.service';
import { TransportDocumentLinesColumns } from '../transport-document-lines';

export function InvoicedMovements() {
  const translationPrefix = 'pages.ddt';
  const { t } = useTranslation();
  const columns: GridColDef[] = TransportDocumentLinesColumns(true);

  return (
    <TenantPage
      title={t('pages.ddt.list.invoiced-movements')}
      subtitle={t(`${translationPrefix}.list.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={transportDocumentLineService}
        getMethod={transportDocumentLineService.invoicedMovements}
        initialParams={{ closed: 'true' }}
      />
    </TenantPage>
  );
}

export default InvoicedMovements;
